import api from './api';

export interface ConnectAccountSummary {
  id: string;
  country?: string | null;
  business_type?: string | null;
  business_profile?: { name?: string | null } | null;
  charges_enabled: boolean;
  payouts_enabled: boolean;
  details_submitted: boolean;
}

export interface ConnectStatusResponse {
  connected: boolean;
  enabled: boolean;
  account: ConnectAccountSummary | null;
}

// Start Stripe Connect Express onboarding and get the hosted onboarding URL
export const startConnectOnboarding = async (
  comercioKey: string
): Promise<{ url: string; account_id: string }> => {
  const { data } = await api.post(
    `/comercios/${encodeURIComponent(comercioKey)}/stripe/connect/start`
  );
  return data;
};

// Retrieve connected account status and update DB flags in backend
export const getConnectStatus = async (
  comercioKey: string
): Promise<ConnectStatusResponse> => {
  const { data } = await api.get(
    `/comercios/${encodeURIComponent(comercioKey)}/stripe/connect/status`
  );
  return data;
};

// Create a short-lived Express Dashboard login link for the operator
export const createExpressLoginLink = async (
  comercioKey: string
): Promise<{ url: string }> => {
  const { data } = await api.post(
    `/comercios/${encodeURIComponent(comercioKey)}/stripe/connect/login-link`
  );
  return data;
};